/**
 * @mention autocomplete inside a private note.
 *
 * A trailing-match heuristic, the same one the quick-reply shortcut already uses for `/` —
 * only the "@" nearest the end of what has been typed so far is ever live, so normal typing
 * elsewhere in a note is never interrupted by a stray "@" earlier in the text.
 */

const MENTION_PATTERN = /@([a-zA-Z0-9 ._-]*)$/

/** The partial name after a trailing "@", or null if the draft does not currently end in one. */
export function mentionQuery(draft: string): string | null {
  const match = MENTION_PATTERN.exec(draft)
  return match ? match[1] : null
}

/** Teammates whose name starts with the partial query, case-insensitively. */
export function matchMentionCandidates<T extends { name: string }>(query: string, members: T[]): T[] {
  const needle = query.toLowerCase()
  return members.filter((m) => m.name.toLowerCase().startsWith(needle))
}

/** Replaces the trailing "@partial" with the full "@Name " once a candidate is chosen. */
export function insertMention(draft: string, name: string): string {
  const at = draft.lastIndexOf('@')
  if (at === -1) return draft
  return draft.slice(0, at) + '@' + name + ' '
}
